let machine = {
	name: "My machine",
	alphabet: ["a", "b", "c"],
	states: [
		{
			id: 0,
			name: "e0",
			x: -100,
			y: -100,
		},
		{
			id: 1,
			name: "e1",
			x: 100,
			y: -100,
		},
	],
	initialStateID: 0, // ID of the initial state
	acceptStatesIDs: [1], // IDs of the accept states
	transitions: [
		{
			id: 0,
			start: 0,
			end: 1,
			x: 0,
			y: 0,
			symbols: ["a", "b"],
		},
	],
};

export default machine;
